import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { Chart, ChartDataSets, ChartOptions } from 'chart.js';

@Component({
  selector: 'bar-chart',
  template: `
    <div style="display: block;">
      <canvas [id]=canvasId></canvas>
    </div>
  `,
  styleUrls: ['./bar-chart.component.scss']
})
export class BarChartComponent implements OnInit, AfterViewInit {
  @Input() barChartData: ChartDataSets[];
  @Input() barChartLabels: string[];
  @Input() canvasId: string;

  chart: Chart;

  public barChartOptions: ChartOptions = {
    responsive: true,
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true
        }
      }]
    },
    legend: {
      display: false
    },
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
        formatter: (value, context) => {
          return '';
        }
      }
    }
  };

  public barChartLegend = true;
  public barChartPlugins = [];
  public barChartType = 'bar';

  constructor() {}

  ngOnInit() {}

  ngAfterViewInit() {
    this.createChart();
  }

  createChart() {
    this.chart = new Chart(this.canvasId, {
      type: 'bar',
      data: {
        labels: this.barChartLabels,
        datasets: this.barChartData,
      },
      options: this.barChartOptions,
    });
  }
}



// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/dashboard/bar-chart/bar-chart.component.ts